<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
       <vs-list>
        <vs-list-header title="억양에 유의하여 원어민 발음으로 말해보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>
      <div class="ww-jumbotron-content-sentence lg:p-4 md:p-3 sm:p-2 p-2 rounded-lg mb-2 text-center">
        <h5 class="text-primary">{{ content.sentence }}</h5>
      </div>
      <div class="ww-jumbotron-content-translation lg:p-4 md:p-3 sm:p-2 p-2 rounded-lg mb-4 text-center" >
        <h5 class="text-success">{{ content.translation}}</h5>
      </div>

      <!-- <vx-card> -->
        <div class="vx-row">
          <div class="vx-col sm:w-1/5 md:w-1/5 w-full ">
             <vs-chip color="primary">원어민</vs-chip>
          </div>
          <div class="vx-col sm:w-4/5 md:w-4/5 w-full">
            <AvWaveform 
              :audio-controls="false"
              :audio-src="content.audio"
              @onAudioFinished="audioFinish"
              ref="waveForm1">
            </AvWaveform>
          </div>
        </div>
        <vs-divider></vs-divider>
      <!-- </vx-card> -->
      <!-- <vx-card>     -->
        <div class="vx-row">
          <div class="vx-col sm:w-1/5 md:w-1/5 w-full">
            <vs-chip color="success">학습자</vs-chip>
          </div>
          <div class="vx-col sm:w-4/5 md:w-4/5 w-full">
            <AvWaveform v-if="recordingFinished"
              :audio-controls="false"
              :audio-src="recording"
              @onAudioFinished="userAudioFinish"
              ref="waveForm2">
            </AvWaveform>
            <div v-if="audioFinished && !recordingFinished">
              <vs-alert  class="text-center" >
                아래 버튼을 누른 상태에서 녹음을 진행합니다. 녹음이 끝나면 버튼을 놓으세요.
              </vs-alert>
              <div class="text-center mt-2">
                <vue-record-audio :mode="recordMode.audio" @result="onResult" />
              </div>
            </div>
          </div>
        </div>  
      <!-- </vx-card> -->
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar from './TopButtonBar.vue'
import AvWaveform from '../../layouts/components/wave-form/AvWaveform.js'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    AvWaveform
  },
  data () {
    return {
      activeNewStepPrompt: true,
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      recordMode: {
        audio: 'hold',
        video: 'press'
      },
      recording: null,
      audioFinished: false,
      recordingFinished: false
      
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    userAudioPlayer () {
      return this.$refs.userAudioPlayer
    }
  },
  methods: {
    onResult (data) {
      this.recording = window.URL.createObjectURL(data)
      this.recordingFinished = true
      
      setTimeout(function () {
        this.$refs.waveForm2.play()
      }.bind(this), 1000)
    },
    onReload () {
      this.contentIndex = 0
      this.audioFinished = false
      this.recordingFinished = false
      this.startAlert()
    },
    onStart () {
      setTimeout(function () {
        this.$refs.waveForm1.play()
      }.bind(this), 1000)
    },
    audioFinish () {
      setTimeout(function () {
        this.audioFinished = true
      }.bind(this), 1000)
    },
    userAudioFinish () {

      setTimeout(function () {
        if (this.contentIndex >= this.contentsLen - 1) {
          this.onComplete()
        } else {
          this.contentIndex++
          this.audioFinished = false
          this.recordingFinished = false
          this.onStart()
        }
      }.bind(this), 3000)
    },
    startAlert () {
      this.startStudyDlg('억양에 유의하여 원어민 발음으로 말해보세요.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)

    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1).replace('http://1.234.63.182', 'http://localhost:8081')
      } 
      this.contentList.push(content)
    }
    ////http://1.234.63.182/ces/SP/L01/B01/U01/R02/SPL01B01U01R020_01.mp3

    // this.contentList = [
    //   {
    //     sentence: 'you',
    //     translation: '너',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_01.mp3'
    //   },
    //   {
    //     sentence: 'slide',
    //     translation: '미끄러지다',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_02.mp3'
    //   },
    //   {
    //     sentence: 'ready',
    //     translation: '준비된',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_03.mp3'
    //   },
    //   {
    //     sentence: 'who',
    //     translation: '누구',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_04.mp3'
    //   },
    //   {
    //     sentence: 'next',
    //     translation: '다음의',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_05.mp3'
    //   },
    //   {
    //     sentence: 'turn',
    //     translation: '순서',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_06.mp3'
    //   }
      
    // ]
    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
.tc-ww-input {
    height: 50px;
    width: 200px;
    font-size: 30px;
    text-align: center;
    letter-spacing:10px;
} 
</style>